import React, { useContext, useState } from "react";
import styles from "./ForgotPassword.module.scss";
import axios from "axios";
import NavContext from "../../context/NavContext";
import Error from "../UiComponents/error/Error";
import Loader from "../UiComponents/loader/Loader";
import { MdOutlineArrowBack } from "react-icons/md";
import Success from "../UiComponents/sucess/Success";
import logo from "../../pics/logo-hearingspace.png";
import forgotImage from "../../pics/forgot-password.jpg";

const ForgotPassword = ({ showForgot, setShowForgot }) => {
  const { loginUser, errorLogin, loaderLogin } = useContext(NavContext);

  const [userMail, setUserMail] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSucess] = useState(false);
  const [msgSuccess, setMsgSucess] = useState("");
  const [msgError, setmsgError] = useState("");

  axios.defaults.withCredentials = true;

  const submitFormsForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_URL}api/sendEmailForNewPass`, {
        userMail: userMail,
      })
      .then(function (response) {
        // ✅ CHANGEMENT: on n'essaie plus de distinguer les cas (anti-énumération)
        // ✅ CHANGEMENT: on affiche le message générique renvoyé par l'API
        setSucess(true);
        setMsgSucess(
          response.data.message ||
            "Si un compte correspond, un email de réinitialisation a été envoyé."
        );
        setTimeout(() => setSucess(false), 2000);
        setLoading(false);
      })
      .catch(function (error) {
        // ✅ CHANGEMENT: même en erreur réseau, on reste neutre
        // (ça évite d'aider un attaquant + UX stable)
        setLoading(false);
        setSucess(true);
        setMsgSucess(
          "Si un compte correspond, un email de réinitialisation a été envoyé."
        );
        setTimeout(() => setSucess(false), 2000);
      });
  };

  return (
    <>
      <header className={styles.header}>
        <img src={logo} alt="Logo" className={styles.logo} />
      </header>

      <div className={styles.back_login} onClick={() => setShowForgot(false)}>
        <MdOutlineArrowBack style={{ fontSize: "25px" }} />
        <span>Retour à la connexion</span>
      </div>

      <div className={styles.heroSection}>
        <div className={styles.leftSide}>
          <h1 className={styles.title}>Mot de passe oublié</h1>
          <form
            className={styles.loginForm}
            onSubmit={submitFormsForgotPassword}
          >
            <div className={styles.formGroup}>
              <label htmlFor="email">Identifiant</label>
              <input
                type="text"
                id="email"
                placeholder="Email de votre compte Hearing Space"
                value={userMail}
                onChange={(e) => setUserMail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className={styles.submitBtn}>
              Réinitialiser mot de passe
            </button>

            <p className={styles.linkEmail}>
              Un lien de réinitialisation vous sera envoyé par email
            </p>

            {loading && <Loader />}
            {error && <Error error={msgError} />}
            {success && <Success success={msgSuccess} />}
          </form>
        </div>

        <div className={styles.rightSide}>
          <img
            src={forgotImage}
            alt="mot de passe oublié"
            className={styles.heroImage}
          />
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
